// import React, { useState, useEffect, useCallback, useMemo } from 'react';
// import { 
//   Plus, Edit2, Trash2, Search, X, Loader2, RefreshCw, 
//   CheckCircle2, XCircle, AlertCircle, Package 
// } from 'lucide-react';
// import { toast } from 'react-toastify';
// import api from '../../common/apiClient';
// import SummaryApi from '../../common/SummaryApi';
// import SelectDropdown from '../../customStyles/SelectDropdown';

// const OurProductList = () => {
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [statusFilter, setStatusFilter] = useState('all'); // all, active, inactive

//   // Modal State for Add / Edit
//   const [modalOpen, setModalOpen] = useState(false);
//   const [editingProduct, setEditingProduct] = useState(null);
//   const [modalLoading, setModalLoading] = useState(false);
//   const [formData, setFormData] = useState({
//     name: '',
//     code: '',
//     description: '',
//     isActive: true,
//   });
//   const [formErrors, setFormErrors] = useState({});

//   // Delete Confirmation Modal State
//   const [deleteModal, setDeleteModal] = useState({ isOpen: false, item: null, loading: false });

//   // 1. Fetch All Products
//   const fetchProducts = useCallback(async () => {
//     setLoading(true);
//     try {
//       const response = await api.get(SummaryApi.getAllProducts.url);
//       if (response.data?.success) {
//         setProducts(response.data.data || []);
//       } else {
//         toast.error(response.data?.message || 'Failed to fetch products');
//       }
//     } catch (error) {
//       console.error('Error fetching products:', error);
//       toast.error(error.response?.data?.message || 'Failed to fetch products');
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchProducts();
//   }, [fetchProducts]);

//   // Open Modal for Create
//   const handleOpenCreate = () => {
//     setEditingProduct(null);
//     setFormData({
//       name: '',
//       code: '',
//       description: '',
//       isActive: true,
//     });
//     setFormErrors({});
//     setModalOpen(true);
//   };

//   // Open Modal for Edit
//   const handleOpenEdit = (product) => {
//     setEditingProduct(product);
//     setFormData({
//       name: product.name || '',
//       code: product.code || '',
//       description: product.description || '',
//       isActive: product.isActive !== undefined ? product.isActive : true,
//     });
//     setFormErrors({});
//     setModalOpen(true);
//   };

//   // Form Validation
//   const validate = () => {
//     const errs = {};
//     if (!formData.name.trim()) errs.name = 'Product name is required';
//     setFormErrors(errs);
//     return Object.keys(errs).length === 0;
//   };

//   // Save (Create or Update)
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;

//     setModalLoading(true);
//     try {
//       const payload = {
//         name: formData.name.trim(),
//         code: formData.code.trim().toUpperCase(),
//         description: formData.description.trim(),
//         isActive: formData.isActive,
//       };

//       let response;
//       if (editingProduct) {
//         const url = typeof SummaryApi.updateProduct.url === 'function' 
//           ? SummaryApi.updateProduct.url(editingProduct._id) 
//           : SummaryApi.updateProduct.url;
//         response = await api.put(url, payload);
//       } else {
//         response = await api.post(SummaryApi.createProduct.url, payload);
//       }

//       if (response.data?.success) {
//         toast.success(editingProduct ? 'Product updated successfully' : 'Product created successfully');
//         setModalOpen(false);
//         fetchProducts();
//       } else {
//         toast.error(response.data?.message || 'Operation failed');
//       }
//     } catch (error) {
//       console.error('Error saving product:', error);
//       toast.error(error.response?.data?.message || 'Error occurred while saving');
//     } finally {
//       setModalLoading(false);
//     }
//   };

//   // Delete Action
//   const handleDeleteConfirm = async () => {
//     if (!deleteModal.item) return;

//     setDeleteModal(prev => ({ ...prev, loading: true }));
//     try {
//       const url = typeof SummaryApi.deleteProduct.url === 'function'
//         ? SummaryApi.deleteProduct.url(deleteModal.item._id)
//         : SummaryApi.deleteProduct.url;

//       const response = await api.delete(url);
//       if (response.data?.success) {
//         toast.success('Product and related categories deleted successfully');
//         setDeleteModal({ isOpen: false, item: null, loading: false });
//         fetchProducts();
//       } else {
//         toast.error(response.data?.message || 'Delete failed');
//       }
//     } catch (error) {
//       console.error('Error deleting product:', error);
//       toast.error(error.response?.data?.message || 'Failed to delete product');
//     } finally {
//       setDeleteModal(prev => ({ ...prev, loading: false }));
//     }
//   };

//   // Client-side Search and Status Filtering
//   const filteredProducts = useMemo(() => {
//     return products.filter(item => {
//       const matchSearch = 
//         item.name?.toLowerCase().includes(searchTerm.toLowerCase().trim()) ||
//         item.code?.toLowerCase().includes(searchTerm.toLowerCase().trim()) ||
//         item.description?.toLowerCase().includes(searchTerm.toLowerCase().trim());

//       const matchStatus = 
//         statusFilter === 'all' ? true :
//         statusFilter === 'active' ? item.isActive === true :
//         item.isActive === false;

//       return matchSearch && matchStatus;
//     });
//   }, [products, searchTerm, statusFilter]);

//   return (
//     <div className="p-2">
//       {/* Top Header Card */}
//       <div className=" p-4 mb-2">
//         <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
//           <div className="flex items-center gap-3">
//             <div className="p-2.5 bg-red-50 text-primary rounded-lg">
//               <Package className="w-6 h-6" />
//             </div>
//             <div>
//               <h1 className="text-xl md:text-2xl font-bold text-gray-900">Our ERP Products</h1>
//               <p className="text-xs md:text-sm text-gray-500">Manage your software solutions and ERP editions</p>
//             </div>
//           </div>
          
//           <button
//             onClick={handleOpenCreate}
//             className="flex items-center justify-center gap-2 bg-primary text-white px-4 py-2.5 rounded-lg text-sm font-medium shadow-sm transition-colors"
//           >
//             <Plus className="w-4 h-4" />
//             <span>Add New Product</span>
//           </button>
//         </div>

//         {/* Filter & Search Bar */}
//         <div className="mt-6 flex flex-col md:flex-row gap-3 items-center justify-between pt-4 border-t border-gray-100">
//           <div className="relative w-full md:w-80">
//             <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
//             <input
//               type="text"
//               placeholder="Search by product name, code..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className="w-full pl-9 pr-8 py-2 text-sm bg-gray-50 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:bg-white transition-all"
//             />
//             {searchTerm && (
//               <button 
//                 onClick={() => setSearchTerm('')} 
//                 className="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
//               >
//                 <X className="w-4 h-4" />
//               </button>
//             )}
//           </div>

//           <div className="flex items-center gap-2 w-full md:w-auto">
//             <SelectDropdown
//               options={[
//                 { value: 'all', label: 'All Status' },
//                 { value: 'active', label: 'Active' },
//                 { value: 'inactive', label: 'Inactive' },
//               ]}
//               value={statusFilter}
//               onChange={(value) => setStatusFilter(value)}
//               placeholder="Select Status"
//               valueKey="value"
//               labelKey="label"
//               searchable={false}
//               className="w-full md:w-auto"
//             />

//             <button
//               onClick={fetchProducts}
//               disabled={loading}
//               className="p-2 border border-gray-300 hover:bg-gray-100 rounded-lg text-gray-600 transition-colors"
//               title="Refresh"
//             >
//               <RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Table Data */}
//       <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
//         {loading ? (
//           <div className="flex flex-col items-center justify-center p-12">
//             <Loader2 className="w-8 h-8 text-primary animate-spin mb-3" />
//             <p className="text-sm text-gray-500">Loading products...</p>
//           </div>
//         ) : filteredProducts.length === 0 ? (
//           <div className="text-center p-12">
//             <Package className="w-12 h-12 text-gray-300 mx-auto mb-3" />
//             <h3 className="text-base font-semibold text-gray-700">No products found</h3>
//             <p className="text-xs text-gray-400 mt-1">
//               {searchTerm ? 'Try adjusting your search criteria' : 'Click "Add New Product" to register your first product'}
//             </p>
//           </div>
//         ) : (
//           <div className="overflow-x-auto">
//             <table className="min-w-full divide-y divide-gray-200 text-left text-sm">
//               <thead className="bg-gray-50 text-gray-600 font-medium">
//                 <tr>
//                   <th className="py-3.5 px-4 w-14 text-center">S.No</th>
//                   <th className="py-3.5 px-4">Product Name</th>
//                   <th className="py-3.5 px-4">Product Code</th>
//                   <th className="py-3.5 px-4">Description</th>
//                   <th className="py-3.5 px-4 text-center">Status</th>
//                   <th className="py-3.5 px-4 text-center w-28">Actions</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-gray-100">
//                 {filteredProducts.map((prod, idx) => (
//                   <tr key={prod._id} className="hover:bg-gray-50/70 transition-colors">
//                     <td className="py-3.5 px-4 text-center text-gray-500">{idx + 1}</td>
//                     <td className="py-3.5 px-4">
//                       <span className="font-semibold text-gray-900">{prod.name}</span>
//                     </td>
//                     <td className="py-3.5 px-4">
//                       {prod.code ? (
//                         <span className="inline-block px-2 py-0.5 font-mono text-xs font-semibold bg-gray-100 text-gray-800 rounded">
//                           {prod.code}
//                         </span>
//                       ) : (
//                         <span className="text-gray-400">-</span>
//                       )}
//                     </td>
//                     <td className="py-3.5 px-4 text-gray-500 max-w-xs truncate">
//                       {prod.description || '-'}
//                     </td>
//                     <td className="py-3.5 px-4 text-center">
//                       <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium ${
//                         prod.isActive 
//                           ? 'bg-green-100 text-green-700' 
//                           : 'bg-red-100 text-red-700'
//                       }`}>
//                         {prod.isActive ? <CheckCircle2 className="w-3 h-3" /> : <XCircle className="w-3 h-3" />}
//                         {prod.isActive ? 'Active' : 'Inactive'}
//                       </span>
//                     </td>
//                     <td className="py-3.5 px-4">
//                       <div className="flex items-center justify-center gap-2">
//                         <button
//                           onClick={() => handleOpenEdit(prod)}
//                           className="p-1.5 text-primary hover:bg-red-50 rounded-lg transition-colors"
//                           title="Edit Product"
//                         >
//                           <Edit2 className="w-4 h-4" />
//                         </button>
//                         <button
//                           onClick={() => setDeleteModal({ isOpen: true, item: prod, loading: false })}
//                           className="p-1.5 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
//                           title="Delete Product"
//                         >
//                           <Trash2 className="w-4 h-4" />
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </div>

//       {/* Add / Edit Product Modal */}
//       {modalOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-fade-in">
//           <div className="bg-white rounded-xl shadow-xl w-full max-w-md overflow-hidden">
//             <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
//               <h3 className="text-lg font-bold text-gray-900">
//                 {editingProduct ? 'Edit ERP Product' : 'Add New ERP Product'}
//               </h3>
//               <button 
//                 onClick={() => setModalOpen(false)}
//                 className="text-gray-400 hover:text-gray-600 rounded-lg p-1"
//               >
//                 <X className="w-5 h-5" />
//               </button>
//             </div>

//             <form onSubmit={handleSubmit} className="p-5 space-y-4">
//               <div>
//                 <label className="block text-xs font-semibold text-gray-700 uppercase mb-1">
//                   Product Name <span className="text-red-500">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   placeholder="e.g. Custom Tailor ERP"
//                   value={formData.name}
//                   onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
//                   className={`w-full px-3 py-2 text-sm border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 ${
//                     formErrors.name ? 'border-red-500' : 'border-gray-300'
//                   }`}
//                 />
//                 {formErrors.name && <p className="text-red-500 text-xs mt-1">{formErrors.name}</p>}
//               </div>

//               <div>
//                 <label className="block text-xs font-semibold text-gray-700 uppercase mb-1">
//                   Product Code
//                 </label>
//                 <input
//                   type="text"
//                   placeholder="e.g. CUSO-TLR"
//                   value={formData.code}
//                   onChange={(e) => setFormData(prev => ({ ...prev, code: e.target.value.toUpperCase() }))}
//                   className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 uppercase font-mono"
//                 />
//               </div>

//               <div>
//                 <label className="block text-xs font-semibold text-gray-700 uppercase mb-1">
//                   Description
//                 </label>
//                 <textarea
//                   rows="3"
//                   placeholder="Enter details about this software/module..."
//                   value={formData.description}
//                   onChange={(e) => setFormData(prev => ({ ...prev, description: e.target.value }))}
//                   className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 resize-none"
//                 />
//               </div>

//               <div className="flex items-center gap-2 pt-1">
//                 <input
//                   type="checkbox"
//                   id="isActiveToggle"
//                   checked={formData.isActive}
//                   onChange={(e) => setFormData(prev => ({ ...prev, isActive: e.target.checked }))}
//                   className="w-4 h-4 text-primary rounded border-gray-300 focus:ring-red-500 cursor-pointer"
//                 />
//                 <label htmlFor="isActiveToggle" className="text-sm font-medium text-gray-700 cursor-pointer select-none">
//                   Active Product
//                 </label>
//               </div>

//               <div className="flex justify-end gap-2 pt-4 border-t border-gray-100">
//                 <button
//                   type="button"
//                   onClick={() => setModalOpen(false)}
//                   disabled={modalLoading}
//                   className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   disabled={modalLoading}
//                   className="flex items-center gap-1.5 px-4 py-2 text-sm font-medium text-white bg-primary rounded-lg transition-colors shadow-sm disabled:opacity-60"
//                 >
//                   {modalLoading && <Loader2 className="w-4 h-4 animate-spin" />}
//                   <span>{editingProduct ? 'Update Product' : 'Create Product'}</span>
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Delete Confirmation Modal */}
//       {deleteModal.isOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-fade-in">
//           <div className="bg-white rounded-xl shadow-xl w-full max-w-sm p-5 text-center">
//             <div className="w-12 h-12 bg-red-100 text-red-600 rounded-full flex items-center justify-center mx-auto mb-3">
//               <AlertCircle className="w-6 h-6" />
//             </div>
//             <h3 className="text-base font-bold text-gray-900 mb-1">Delete ERP Product?</h3>
//             <p className="text-xs text-gray-500 mb-4">
//               Are you sure you want to delete <strong className="text-gray-800">{deleteModal.item?.name}</strong>? 
//               All associated business categories will also be permanently removed.
//             </p>
//             <div className="flex justify-center gap-2">
//               <button
//                 type="button"
//                 onClick={() => setDeleteModal({ isOpen: false, item: null, loading: false })}
//                 disabled={deleteModal.loading}
//                 className="px-4 py-2 text-xs font-semibold text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg"
//               >
//                 Cancel
//               </button>
//               <button
//                 type="button"
//                 onClick={handleDeleteConfirm}
//                 disabled={deleteModal.loading}
//                 className="flex items-center gap-1.5 px-4 py-2 text-xs font-semibold text-white bg-red-600 hover:bg-red-700 rounded-lg shadow-sm disabled:opacity-60"
//               >
//                 {deleteModal.loading && <Loader2 className="w-3.5 h-3.5 animate-spin" />}
//                 <span>Delete Product</span>
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default OurProductList;

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { 
  Plus, Edit2, Trash2, Search, X, Loader2, RefreshCw, 
  CheckCircle2, XCircle, AlertCircle, Layers, GitBranch 
} from 'lucide-react';
import { toast } from 'react-toastify';
import api from '../../common/apiClient';
import SummaryApi from '../../common/SummaryApi';
import SelectDropdown from '../../customStyles/SelectDropdown';

const OurProductList = () => {
  const [verticals, setVerticals] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all'); // all, active, inactive
  const [verticalFilter, setVerticalFilter] = useState('all'); // all, active, inactive
  const [divisionFilter, setDivisionFilter] = useState('all'); // filter by division

  // Modal State for Add / Edit
  const [modalOpen, setModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);
  
  // Form State with Division & hasSubCategory
  const [formData, setFormData] = useState({
    divisionId: '',
    name: '',
    code: '',
    description: '',
    hasSubCategory: false,
    isVertical: true,
    isActive: true,
  });
  const [formErrors, setFormErrors] = useState({});

  // Delete Confirmation Modal State
  const [deleteModal, setDeleteModal] = useState({ isOpen: false, item: null, loading: false });

  // 1. Fetch Divisions for Dropdowns
  const fetchDivisions = useCallback(async () => {
    try {
      const url = SummaryApi.getAllDivisions?.url || SummaryApi.getDivisions?.url;
      if (!url) return;
      const response = await api.get(url);
      if (response.data?.success) {
        setDivisions(response.data.data || []);
      }
    } catch (error) {
      console.error('Error fetching divisions:', error);
    }
  }, []);

  // 2. Fetch All Business Verticals
  const fetchVerticals = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get(SummaryApi.getAllProducts.url);
      if (response.data?.success) {
        setVerticals(response.data.data || []);
      } else {
        toast.error(response.data?.message || 'Failed to fetch business verticals');
      }
    } catch (error) {
      console.error('Error fetching business verticals:', error);
      toast.error(error.response?.data?.message || 'Failed to fetch business verticals');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDivisions();
    fetchVerticals();
  }, [fetchDivisions, fetchVerticals]);

  // Open Modal for Create
  const handleOpenCreate = () => {
    setEditingItem(null);
    setFormData({
      divisionId: '',
      name: '',
      code: '',
      description: '',
      hasSubCategory: false,
      isVertical: true,
      isActive: true,
    });
    setFormErrors({});
    setModalOpen(true);
  };

  // Open Modal for Edit
  const handleOpenEdit = (item) => {
    setEditingItem(item);
    setFormData({
      divisionId: item.divisionId?._id || item.divisionId || '',
      name: item.name || '',
      code: item.code || '',
      description: item.description || '',
      hasSubCategory: item.hasSubCategory || false,
      isVertical: item.isVertical !== undefined ? item.isVertical : true,
      isActive: item.isActive !== undefined ? item.isActive : true,
    });
    setFormErrors({});
    setModalOpen(true);
  };

  // Form Validation
  const validate = () => {
    const errs = {};
    if (!formData.divisionId) errs.divisionId = 'Division is required';
    if (!formData.name.trim()) errs.name = 'Vertical name is required';
    setFormErrors(errs);
    return Object.keys(errs).length === 0;
  };

  // Save (Create or Update)
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setModalLoading(true);
    try {
      const payload = {
        divisionId: formData.divisionId,
        name: formData.name.trim(),
        code: formData.code.trim().toUpperCase(),
        description: formData.description.trim(),
        hasSubCategory: formData.hasSubCategory,
        isVertical: formData.isVertical,
        isActive: formData.isActive,
      };

      let response;
      if (editingItem) {
        const url = typeof SummaryApi.updateProduct.url === 'function' 
          ? SummaryApi.updateProduct.url(editingItem._id) 
          : SummaryApi.updateProduct.url;
        response = await api.put(url, payload);
      } else {
        response = await api.post(SummaryApi.createProduct.url, payload);
      }

      if (response.data?.success) {
        toast.success(editingItem ? 'Business vertical updated successfully' : 'Business vertical created successfully');
        setModalOpen(false);
        fetchVerticals();
      } else {
        toast.error(response.data?.message || 'Operation failed');
      }
    } catch (error) {
      console.error('Error saving business vertical:', error);
      toast.error(error.response?.data?.message || 'Error occurred while saving');
    } finally {
      setModalLoading(false);
    }
  };

  // Delete Action
  const handleDeleteConfirm = async () => {
    if (!deleteModal.item) return;

    setDeleteModal(prev => ({ ...prev, loading: true }));
    try {
      const url = typeof SummaryApi.deleteProduct.url === 'function'
        ? SummaryApi.deleteProduct.url(deleteModal.item._id)
        : SummaryApi.deleteProduct.url;

      const response = await api.delete(url);
      if (response.data?.success) {
        toast.success('Business vertical and related sub-categories deleted successfully');
        setDeleteModal({ isOpen: false, item: null, loading: false });
        fetchVerticals();
      } else {
        toast.error(response.data?.message || 'Delete failed');
      }
    } catch (error) {
      console.error('Error deleting vertical:', error);
      toast.error(error.response?.data?.message || 'Failed to delete business vertical');
    } finally {
      setDeleteModal(prev => ({ ...prev, loading: false }));
    }
  };

  // Client-side Search and Filters
  const filteredVerticals = useMemo(() => {
    return verticals.filter(item => {
      const divisionName = item.divisionId?.name || '';
      const matchSearch = 
        item.name?.toLowerCase().includes(searchTerm.toLowerCase().trim()) ||
        item.code?.toLowerCase().includes(searchTerm.toLowerCase().trim()) ||
        divisionName?.toLowerCase().includes(searchTerm.toLowerCase().trim()) ||
        item.description?.toLowerCase().includes(searchTerm.toLowerCase().trim());

      const matchStatus = 
        statusFilter === 'all' ? true :
        statusFilter === 'active' ? item.isActive === true :
        item.isActive === false;
      
      const matchVertical = 
        verticalFilter === 'all' ? true :
        verticalFilter === 'Yes' ? item.isVertical === true :
        item.isVertical === false;

      const itemDivisionId = item.divisionId?._id || item.divisionId;
      const matchDivision = 
        divisionFilter === 'all' ? true :
        itemDivisionId === divisionFilter;

      return matchSearch && matchStatus && matchVertical && matchDivision;
    });
  }, [verticals, searchTerm, statusFilter, verticalFilter, divisionFilter]);

  return (
    <div className="p-2">
      {/* Top Header Card */}
      <div className="p-4 mb-2">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="p-2.5 bg-red-50 text-primary rounded-lg">
              <Layers className="w-6 h-6" />
            </div>
            <div>
              <h1 className="text-xl md:text-2xl font-bold text-gray-900">Business Verticals / Products</h1>
              <p className="text-xs md:text-sm text-gray-500">
                Manage your business verticals and product lines under each division
              </p>
            </div>
          </div>
          
          <button
            onClick={handleOpenCreate}
            className="flex items-center justify-center gap-2 bg-primary text-white px-4 py-2.5 rounded-lg text-sm font-medium shadow-sm transition-colors"
          >
            <Plus className="w-4 h-4" />
            <span>Add Business Vertical</span>
          </button>
        </div>

        {/* Filter & Search Bar */}
        <div className="mt-6 flex flex-col md:flex-row gap-3 items-center justify-between pt-4 border-t border-gray-100">
          <div className="relative w-full md:w-80">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
            <input
              type="text"
              placeholder="Search by vertical name, division, code..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-9 pr-8 py-2 text-sm bg-gray-50 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:bg-white transition-all"
            />
            {searchTerm && (
              <button 
                onClick={() => setSearchTerm('')} 
                className="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                <X className="w-4 h-4" />
              </button>
            )}
          </div>

          <div className="flex flex-wrap items-center gap-2 w-full md:w-auto">
            {/* Division Filter */}
            <div className="w-full sm:w-48">
              <SelectDropdown
                options={[
                  { _id: 'all', name: 'All Divisions' },
                  ...divisions
                ]}
                value={divisionFilter}
                onChange={(value) => setDivisionFilter(value)}
                placeholder="Filter by Division"
                valueKey="_id"
                labelKey="name"
                searchable={true}
              />
            </div>

            {/* Vertical Filter */}
            <div className="w-full sm:w-36">
              <SelectDropdown
                options={[
                  { value: 'all', label: 'All Verticals' },
                  { value: 'Yes', label: 'Yes' },
                  { value: 'No', label: 'No' },
                ]}
                value={verticalFilter}
                onChange={(value) => setVerticalFilter(value)}
                placeholder="Select Vertical"
                valueKey="value"
                labelKey="label"
                searchable={false}
              />
            </div>

            {/* Status Filter */}
            <div className="w-full sm:w-36">
              <SelectDropdown
                options={[
                  { value: 'all', label: 'All Status' },
                  { value: 'active', label: 'Active' },
                  { value: 'inactive', label: 'Inactive' },
                ]}
                value={statusFilter}
                onChange={(value) => setStatusFilter(value)}
                placeholder="Select Status"
                valueKey="value"
                labelKey="label"
                searchable={false}
              />
            </div>

            <button
              onClick={() => { fetchDivisions(); fetchVerticals(); }}
              disabled={loading}
              className="p-2 border border-gray-300 hover:bg-gray-100 rounded-lg text-gray-600 transition-colors"
              title="Refresh"
            >
              <RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
            </button>
          </div>
        </div>
      </div>

      {/* Table Data */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        {loading ? (
          <div className="flex flex-col items-center justify-center p-12">
            <Loader2 className="w-8 h-8 text-primary animate-spin mb-3" />
            <p className="text-sm text-gray-500">Loading business verticals...</p>
          </div>
        ) : filteredVerticals.length === 0 ? (
          <div className="text-center p-12">
            <Layers className="w-12 h-12 text-gray-300 mx-auto mb-3" />
            <h3 className="text-base font-semibold text-gray-700">No business verticals found</h3>
            <p className="text-xs text-gray-400 mt-1">
              {searchTerm || divisionFilter !== 'all' 
                ? 'Try adjusting your search or filter criteria' 
                : 'Click "Add Business Vertical" to register your first vertical'}
            </p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200 text-left text-sm">
              <thead className="bg-gray-50 text-gray-600 font-medium">
                <tr>
                  <th className="py-3.5 px-4 w-14 text-center">S.No</th>
                  <th className="py-3.5 px-4">Vertical Name</th>
                  <th className="py-3.5 px-4">Division</th>
                  <th className="py-3.5 px-4">Code</th>
                  <th className="py-3.5 px-4 text-center">Has Sub-Categories</th>
                  <th className="py-3.5 px-4">Description</th>
                  <th className="py-3.5 px-4 text-center">Business Verticals</th>
                  <th className="py-3.5 px-4 text-center">Status</th>
                  <th className="py-3.5 px-4 text-center w-28">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {filteredVerticals.map((item, idx) => (
                  <tr key={item._id} className="hover:bg-gray-50/70 transition-colors">
                    <td className="py-3.5 px-4 text-center text-gray-500">{idx + 1}</td>
                    
                    {/* Vertical Name */}
                    <td className="py-3.5 px-4">
                      <span className="font-semibold text-gray-900">{item.name}</span>
                    </td>

                    {/* Division Name */}
                    <td className="py-3.5 px-4">
                      {item.divisionId?.name ? (
                        <span className="inline-block px-2.5 py-0.5 text-xs font-medium bg-blue-50 text-blue-700 rounded-full border border-blue-200">
                          {item.divisionId.name}
                        </span>
                      ) : (
                        <span className="text-gray-400">-</span>
                      )}
                    </td>

                    {/* Code */}
                    <td className="py-3.5 px-4">
                      {item.code ? (
                        <span className="inline-block px-2 py-0.5 font-mono text-xs font-semibold bg-gray-100 text-gray-800 rounded">
                          {item.code}
                        </span>
                      ) : (
                        <span className="text-gray-400">-</span>
                      )}
                    </td>

                    {/* Sub-Category Badge */}
                    <td className="py-3.5 px-4 text-center">
                      <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium ${
                        item.hasSubCategory 
                          ? 'bg-purple-50 text-purple-700 border border-purple-200' 
                          : 'bg-gray-100 text-gray-600'
                      }`}>
                        <GitBranch className="w-3 h-3" />
                        {item.hasSubCategory ? 'Yes' : 'No'}
                      </span>
                    </td>

                    {/* Description */}
                    <td className="py-3.5 px-4 text-gray-500 max-w-xs truncate">
                      {item.description || '-'}
                    </td>

                    {/* Status */}
                    <td className="py-3.5 px-4 text-center">
                      <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium ${
                        item.isVertical 
                          ? 'bg-green-100 text-green-700' 
                          : 'bg-blue-100 text-blue-700'
                      }`}>
                        {item.isVertical ? <CheckCircle2 className="w-3 h-3" /> : <XCircle className="w-3 h-3" />}
                        {item.isVertical ? 'Yes' : 'No'}
                      </span>
                    </td>
                    <td className="py-3.5 px-4 text-center">
                      <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium ${
                        item.isActive 
                          ? 'bg-green-100 text-green-700' 
                          : 'bg-red-100 text-red-700'
                      }`}>
                        {item.isActive ? <CheckCircle2 className="w-3 h-3" /> : <XCircle className="w-3 h-3" />}
                        {item.isActive ? 'Active' : 'Inactive'}
                      </span>
                    </td>

                    {/* Actions */}
                    <td className="py-3.5 px-4">
                      <div className="flex items-center justify-center gap-2">
                        <button
                          onClick={() => handleOpenEdit(item)}
                          className="p-1.5 text-primary hover:bg-red-50 rounded-lg transition-colors"
                          title="Edit Vertical"
                        >
                          <Edit2 className="w-4 h-4" />
                        </button>
                        <button
                          onClick={() => setDeleteModal({ isOpen: true, item, loading: false })}
                          className="p-1.5 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                          title="Delete Vertical"
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Add / Edit Modal */}
      {modalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-fade-in">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-md overflow-hidden">
            <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
              <h3 className="text-lg font-bold text-gray-900">
                {editingItem ? 'Edit Business Vertical' : 'Add New Business Vertical'}
              </h3>
              <button 
                onClick={() => setModalOpen(false)}
                className="text-gray-400 hover:text-gray-600 rounded-lg p-1"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="p-5 space-y-4">
              {/* Division Dropdown */}
              <div>
                <label className="block text-xs font-semibold text-gray-700 uppercase mb-1">
                  Division <span className="text-red-500">*</span>
                </label>
                <SelectDropdown
                  options={divisions}
                  value={formData.divisionId}
                  onChange={(val) => {
                    setFormData(prev => ({ ...prev, divisionId: val }));
                    if (formErrors.divisionId) setFormErrors(prev => ({ ...prev, divisionId: null }));
                  }}
                  placeholder="Select Division"
                  valueKey="_id"
                  labelKey="name"
                  searchable={true}
                  zIndex={71}
                />
                {formErrors.divisionId && (
                  <p className="text-red-500 text-xs mt-1">{formErrors.divisionId}</p>
                )}
              </div>

              {/* Vertical Name */}
              <div>
                <label className="block text-xs font-semibold text-gray-700 uppercase mb-1">
                  Vertical Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder="e.g. Healthcare ERP / Retail POS"
                  value={formData.name}
                  onChange={(e) => {
                    setFormData(prev => ({ ...prev, name: e.target.value }));
                    if (formErrors.name) setFormErrors(prev => ({ ...prev, name: null }));
                  }}
                  className={`w-full px-3 py-2 text-sm border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 ${
                    formErrors.name ? 'border-red-500' : 'border-gray-300'
                  }`}
                />
                {formErrors.name && <p className="text-red-500 text-xs mt-1">{formErrors.name}</p>}
              </div>

              {/* Vertical Code */}
              <div>
                <label className="block text-xs font-semibold text-gray-700 uppercase mb-1">
                  Vertical Code
                </label>
                <input
                  type="text"
                  placeholder="e.g. VRT-HLTH"
                  value={formData.code}
                  onChange={(e) => setFormData(prev => ({ ...prev, code: e.target.value.toUpperCase() }))}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 uppercase font-mono"
                />
              </div>

              {/* Description */}
              <div>
                <label className="block text-xs font-semibold text-gray-700 uppercase mb-1">
                  Description
                </label>
                <textarea
                  rows="3"
                  placeholder="Enter details about this business vertical..."
                  value={formData.description}
                  onChange={(e) => setFormData(prev => ({ ...prev, description: e.target.value }))}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 resize-none"
                />
              </div>

              {/* Has Sub-Category Checkbox */}
              <div className="p-3 bg-gray-50 rounded-lg border border-gray-200">
                <div className="flex items-start gap-2.5">
                  <input
                    type="checkbox"
                    id="hasSubCategoryToggle"
                    checked={formData.hasSubCategory}
                    onChange={(e) => setFormData(prev => ({ ...prev, hasSubCategory: e.target.checked }))}
                    className="w-4 h-4 mt-0.5 text-primary rounded border-gray-300 focus:ring-red-500 cursor-pointer"
                  />
                  <div>
                    <label htmlFor="hasSubCategoryToggle" className="text-sm font-semibold text-gray-800 cursor-pointer select-none">
                      Enable Sub-Categories
                    </label>
                    <p className="text-xs text-gray-500 mt-0.5">
                      Enable this if this vertical requires deeper sub-categories/business categories.
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-6 pt-1">
                {/* Business Vertical */}
                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    id="isVerticalToggle"
                    checked={formData.isVertical}
                    onChange={(e) =>
                      setFormData(prev => ({
                        ...prev,
                        isVertical: e.target.checked
                      }))
                    }
                    className="w-4 h-4 text-primary rounded border-gray-300 focus:ring-red-500 cursor-pointer"
                  />
                  <label
                    htmlFor="isVerticalToggle"
                    className="text-sm font-medium text-gray-700 cursor-pointer select-none"
                  >
                    Business Vertical
                  </label>
                </div>

                {/* Active Status */}
                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    id="isActiveToggle"
                    checked={formData.isActive}
                    onChange={(e) =>
                      setFormData(prev => ({
                        ...prev,
                        isActive: e.target.checked
                      }))
                    }
                    className="w-4 h-4 text-primary rounded border-gray-300 focus:ring-red-500 cursor-pointer"
                  />
                  <label
                    htmlFor="isActiveToggle"
                    className="text-sm font-medium text-gray-700 cursor-pointer select-none"
                  >
                    Active Status
                  </label>
                </div>
              </div>

              {/* Buttons */}
              <div className="flex justify-end gap-2 pt-4 border-t border-gray-100">
                <button
                  type="button"
                  onClick={() => setModalOpen(false)}
                  disabled={modalLoading}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={modalLoading}
                  className="flex items-center gap-1.5 px-4 py-2 text-sm font-medium text-white bg-primary rounded-lg transition-colors shadow-sm disabled:opacity-60"
                >
                  {modalLoading && <Loader2 className="w-4 h-4 animate-spin" />}
                  <span>{editingItem ? 'Update Vertical' : 'Create Vertical'}</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {deleteModal.isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-fade-in">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-sm p-5 text-center">
            <div className="w-12 h-12 bg-red-100 text-red-600 rounded-full flex items-center justify-center mx-auto mb-3">
              <AlertCircle className="w-6 h-6" />
            </div>
            <h3 className="text-base font-bold text-gray-900 mb-1">Delete Business Vertical?</h3>
            <p className="text-xs text-gray-500 mb-4">
              Are you sure you want to delete <strong className="text-gray-800">{deleteModal.item?.name}</strong>? 
              All associated sub-categories mapped to this vertical will also be permanently removed.
            </p>
            <div className="flex justify-center gap-2">
              <button
                type="button"
                onClick={() => setDeleteModal({ isOpen: false, item: null, loading: false })}
                disabled={deleteModal.loading}
                className="px-4 py-2 text-xs font-semibold text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleDeleteConfirm}
                disabled={deleteModal.loading}
                className="flex items-center gap-1.5 px-4 py-2 text-xs font-semibold text-white bg-red-600 hover:bg-red-700 rounded-lg shadow-sm disabled:opacity-60"
              >
                {deleteModal.loading && <Loader2 className="w-3.5 h-3.5 animate-spin" />}
                <span>Delete Vertical</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OurProductList;